import { render, staticRenderFns } from "./privacyThird.vue?vue&type=template&id=1e57c45c&"
import script from "./privacyThird.vue?vue&type=script&lang=js&"
export * from "./privacyThird.vue?vue&type=script&lang=js&"
import style0 from "./privacyThird.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports